import { render, staticRenderFns } from "./CarouselNoticias.vue?vue&type=template&id=73115bb2&"
import script from "./CarouselNoticias.vue?vue&type=script&lang=js&"
export * from "./CarouselNoticias.vue?vue&type=script&lang=js&"
import style0 from "./CarouselNoticias.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports